import { Routes } from '@/config/routes';
import { Controller, useFormContext } from 'react-hook-form';

import { CheckboxGroup, ConsentCheckbox, Fieldset } from '../fields';
import type { DeliveryPartnerFormValues } from '../schema';

interface Props {
  regions: string[];
  weekDays: string[];
  periods: string[];
}

export default function StepPreferencias({
  regions,
  weekDays,
  periods,
}: Props) {
  const {
    control,
    formState: { errors },
  } = useFormContext<DeliveryPartnerFormValues>();

  return (
    <>
      <Fieldset
        legend="Preferências de trabalho"
        description="Suas escolhas nos ajudam a distribuir as rotas. Elas não são um compromisso fixo."
      >
        <div className="space-y-7">
          <Controller
            name="regions"
            control={control}
            render={({ field }) => (
              <CheckboxGroup
                label="Em quais regiões você quer atuar?"
                name="regions"
                options={regions}
                values={field.value ?? []}
                onChange={field.onChange}
                error={errors.regions?.message}
              />
            )}
          />

          <Controller
            name="available_days"
            control={control}
            render={({ field }) => (
              <CheckboxGroup
                label="Quais dias da semana você tem disponibilidade?"
                name="available_days"
                options={weekDays}
                values={field.value ?? []}
                onChange={field.onChange}
                error={errors.available_days?.message}
              />
            )}
          />

          <Controller
            name="preferred_periods"
            control={control}
            render={({ field }) => (
              <CheckboxGroup
                label="Quais períodos você prefere?"
                name="preferred_periods"
                options={periods}
                values={field.value ?? []}
                onChange={field.onChange}
                error={errors.preferred_periods?.message}
              />
            )}
          />
        </div>
      </Fieldset>

      <Fieldset legend="Consentimentos">
        <div className="space-y-4">
          <Controller
            name="accepted_terms"
            control={control}
            render={({ field }) => (
              <ConsentCheckbox
                id="accepted_terms"
                checked={field.value ?? false}
                onChange={field.onChange}
                error={errors.accepted_terms?.message}
              >
                Li e aceito os{' '}
                <a
                  href={Routes.termos}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="font-semibold text-accent underline"
                >
                  Termos e Condições de Uso
                </a>{' '}
                e a{' '}
                <a
                  href={Routes.politica}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="font-semibold text-accent underline"
                >
                  Política de Privacidade
                </a>
                , e autorizo o tratamento dos meus dados para fins de seleção.
              </ConsentCheckbox>
            )}
          />

          <Controller
            name="accepted_safety"
            control={control}
            render={({ field }) => (
              <ConsentCheckbox
                id="accepted_safety"
                checked={field.value ?? false}
                onChange={field.onChange}
                error={errors.accepted_safety?.message}
              >
                Declaro estar ciente das normas de segurança e higiene exigidas
                para o transporte de medicamentos.
              </ConsentCheckbox>
            )}
          />
        </div>
      </Fieldset>
    </>
  );
}
